import { uniq } from 'lodash-es';
import jQuery from 'jquery';

let sortOrderByPageIds = function (collectionId) {
  let ids = [];
  let elems = jQuery('[data-group-id]');

  if (collectionId) {
    elems = jQuery(`[data-group-collection-id="${collectionId}"]`).find('[data-group-id]');
  }

  elems.each(function () {
    ids.push(jQuery(this).data('group-id'));
  });

  return uniq(ids);
};

let collectionSortOrderByPageIds = function () {
  let ids = [];
  jQuery('[data-group-collection-id]').each(function () {
    ids.push(jQuery(this).data('group-collection-id'));
  });
  return ids;
};

export default { sortOrderByPageIds, collectionSortOrderByPageIds };
